// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ij9au","icon":"styles_icon__swTD3","content":"styles_content__MNFKm","title":"styles_title__ikb22","message":"styles_message__jhvL7"};